var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "modal",
    {
      attrs: {
        title: "NOVO DISTRITO",
        subtitle: "Informe os dados do novo distrito",
        size: "md"
      },
      on: {
        close: function($event) {
          return _vm.$emit("close")
        }
      }
    },
    [
      _c("template", { slot: "body" }, [
        _c(
          "div",
          { staticClass: "form-group" },
          [
            _c("InputGroup", {
              directives: [
                {
                  name: "validate",
                  rawName: "v-validate.disabled",
                  value: "required",
                  expression: "'required'",
                  modifiers: { disabled: true }
                }
              ],
              attrs: { error: _vm.errors.first("nome"), label: "nome" },
              model: {
                value: _vm.district.display_name,
                callback: function($$v) {
                  _vm.$set(_vm.district, "display_name", $$v)
                },
                expression: "district.display_name"
              }
            }),
            _vm._v(" "),
            _c("InputGroup", {
              directives: [
                {
                  name: "validate",
                  rawName: "v-validate.disabled",
                  value: "required|max:3",
                  expression: "'required|max:3'",
                  modifiers: { disabled: true }
                }
              ],
              attrs: { error: _vm.errors.first("codigo"), label: "codigo" },
              model: {
                value: _vm.district.code,
                callback: function($$v) {
                  _vm.$set(_vm.district, "code", $$v)
                },
                expression: "district.code"
              }
            })
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "title-form mt-30" }, [_vm._v("NOTAS")]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "form-group" },
          [
            _c("InputGroup", {
              directives: [
                {
                  name: "validate",
                  rawName: "v-validate.disabled",
                  value: "required|min_value:1|max_value:5",
                  expression: "'required|min_value:1|max_value:5'",
                  modifiers: { disabled: true }
                }
              ],
              attrs: {
                error: _vm.errors.first("nota mínima"),
                type: "number",
                label: "nota mínima"
              },
              model: {
                value: _vm.rating_min,
                callback: function($$v) {
                  _vm.rating_min = $$v
                },
                expression: "rating_min"
              }
            }),
            _vm._v(" "),
            _c("InputGroup", {
              directives: [
                {
                  name: "validate",
                  rawName: "v-validate.disabled",
                  value: "required|min_value:1|max_value:5",
                  expression: "'required|min_value:1|max_value:5'",
                  modifiers: { disabled: true }
                }
              ],
              attrs: {
                error: _vm.errors.first("nota máxima"),
                type: "number",
                label: "nota máxima"
              },
              model: {
                value: _vm.rating_max,
                callback: function($$v) {
                  _vm.rating_max = $$v
                },
                expression: "rating_max"
              }
            })
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "title-form mt-30" }, [_vm._v("PREÇOS")]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "form-group" },
          [
            _c("InputGroup", {
              directives: [
                {
                  name: "validate",
                  rawName: "v-validate.disabled",
                  value: "required|min_value:0",
                  expression: "'required|min_value:0'",
                  modifiers: { disabled: true }
                }
              ],
              attrs: {
                error: _vm.errors.first("preço"),
                type: "money",
                label: "preço"
              },
              model: {
                value: _vm.district.pricing.price,
                callback: function($$v) {
                  _vm.$set(_vm.district.pricing, "price", $$v)
                },
                expression: "district.pricing.price"
              }
            }),
            _vm._v(" "),
            _c("InputGroup", {
              directives: [
                {
                  name: "validate",
                  rawName: "v-validate.disabled",
                  value: "required|min_value:0",
                  expression: "'required|min_value:0'",
                  modifiers: { disabled: true }
                }
              ],
              attrs: {
                error: _vm.errors.first("preço por hora"),
                type: "money",
                label: "preço por hora"
              },
              model: {
                value: _vm.district.pricing.price_per_hour,
                callback: function($$v) {
                  _vm.$set(_vm.district.pricing, "price_per_hour", $$v)
                },
                expression: "district.pricing.price_per_hour"
              }
            })
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "form-group" },
          [
            _c("InputGroup", {
              directives: [
                {
                  name: "validate",
                  rawName: "v-validate.disabled",
                  value: "required|min_value:0",
                  expression: "'required|min_value:0'",
                  modifiers: { disabled: true }
                }
              ],
              attrs: {
                error: _vm.errors.first("taxa"),
                type: "money",
                label: "taxa"
              },
              model: {
                value: _vm.district.pricing.fee,
                callback: function($$v) {
                  _vm.$set(_vm.district.pricing, "fee", $$v)
                },
                expression: "district.pricing.fee"
              }
            }),
            _vm._v(" "),
            _c("InputGroup", {
              directives: [
                {
                  name: "validate",
                  rawName: "v-validate.disabled",
                  value: "required|min_value:0",
                  expression: "'required|min_value:0'",
                  modifiers: { disabled: true }
                }
              ],
              attrs: {
                error: _vm.errors.first("taxa por hora"),
                type: "money",
                label: "taxa por hora"
              },
              model: {
                value: _vm.district.pricing.fee_per_hour,
                callback: function($$v) {
                  _vm.$set(_vm.district.pricing, "fee_per_hour", $$v)
                },
                expression: "district.pricing.fee_per_hour"
              }
            })
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c(
        "template",
        { slot: "footer" },
        [
          _c(
            "v-btn",
            {
              on: {
                click: function($event) {
                  return _vm.$emit("close")
                }
              }
            },
            [_vm._v("fechar")]
          ),
          _vm._v(" "),
          _c(
            "v-btn",
            {
              staticClass: "btn bg-purple",
              class: { "btn--loading": _vm.preloader },
              on: { click: _vm.submit }
            },
            [_c("span", [_vm._v("cadastrar")])]
          )
        ],
        1
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0834c998", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0834c998","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Cities/NewDistrict.vue
// module id = null
// module chunks = 